import useInfinitiveScrollableWire from '../../../shared/infinitive-scrollable-wires-hook';

const INIT = 6;

const useScrollableWires = props => useInfinitiveScrollableWire({
  ...props,
  isScrollable: false,
  initNumber: INIT,
  entityName: 'wires',
});

const useScrollableDrafts = props => useInfinitiveScrollableWire({
  ...props,
  isScrollable: false,
  initNumber: INIT,
  entityName: 'drafts',
});

const useScrollablePending = props => useInfinitiveScrollableWire({
  ...props,
  isScrollable: false,
  initNumber: INIT,
  entityName: 'wires',
});

export {
  useScrollableWires,
  useScrollableDrafts,
  useScrollablePending,
};
